
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12.01","height":"12.414"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1245","fill":"none","stroke":"#707070","stroke-linecap":"round"}},[_c('path',{attrs:{"data-name":"Line 139","d":"M11.303.707l-10.596 11"}}),_c('path',{attrs:{"data-name":"Line 140","d":"M11.303 11.707L.707.707"}})])])
          )
        }
      }
    